export const gameKartriderTestSet: string[] = [
  "카트라이더 트랙 이름(풀네임)",
  "카트리이더 카트바디 이름",
]